function reportWindowSize() {

    const pushAnimations = document.querySelectorAll(".push-animation");

    pushAnimations.forEach(function(element) {

        const textDivHeight = element.querySelector('.push-animation-text-tile').getBoundingClientRect().height + 60;
        const imageDiv = element.querySelector('.push-animation-img');

        imageDiv.style.height = "150px";
        if (window.innerWidth >= 480 && window.innerWidth <= 735) {
            imageDiv.style.height = "200px";
        }
        if (window.innerWidth >= 736) {
            imageDiv.style.height = textDivHeight + "px";
        }

    });

}

window.addEventListener('resize', reportWindowSize);
reportWindowSize();
